import { connect } from 'react-redux';
import { toggleSnackBar, toggleModal } from 'state/callers';
import { myAccountSelector } from 'state/selectors/account';
import {
  getIsAllowedToConfigureWorkerBInlineApprovalSelector,
  getSlackSensorAuthorizationSelector
} from 'state/selectors/sensors-authorizations';
import { patchAccount } from 'state/callers/account';
import SlackSettings from './SlackSettings';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { selectTeamId } from 'state/actions';
import { noParentTeamsSelector } from 'state/selectors/teams';

const mapStateToProps = state => {
  const { uiState } = state;
  return {
    uiState,
    account: myAccountSelector(state),
    currentTeams: noParentTeamsSelector(state),
    slackSensorAuthorization: getSlackSensorAuthorizationSelector(state),
    isAllowedToConfigureWorkerBInlineApproval:
      getIsAllowedToConfigureWorkerBInlineApprovalSelector(state)
  };
};

const mapDispatchToProps = {
  toggleSnackBar,
  toggleModal,
  patchAccount,
  selectTeamId
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(SlackSettings, 'Slack Settings'));
